import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectionCell from 'shared/ui/Table/cells/SelectionCell';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';
import { get } from 'lodash';
import Skeleton from 'Common/Components/Skeleton';
import { multipleAgentExecutionSetSelected, selectAllAgentExecutions, unselectAgentExecution, unselectAllAgentExecutions } from 'store/Agents/actions';
import { selectAgentExecutions, selectAgentExecutionSelected } from 'store/Agents/selectors';

const SelectedCell = ({ rowInfo, isHeader, showSkeleton, disabled }) => {
  const dispatch = useDispatch();
  const data = get(rowInfo, 'original', {});
  const rowId = get(rowInfo, 'original.id', '');
  const agentExecutions = useSelector(selectAgentExecutions);
  const agentExecutionsSelected = useSelector(selectAgentExecutionSelected);
  const isSelected = agentExecutionsSelected.some((e) => e.id === rowId);

  const allRowsSelected = agentExecutions.length === agentExecutionsSelected.length;

  const rowClick = () => {
    if (isSelected) dispatch(unselectAgentExecution(data));
    else dispatch(multipleAgentExecutionSetSelected(data));
  };

  const headerClick = () => {
    if (allRowsSelected) {
      dispatch(unselectAllAgentExecutions());
    } else {
      dispatch(selectAllAgentExecutions());
    }
  };

  const onClick = isHeader ? headerClick : rowClick;

  if (showSkeleton) return <Skeleton />;
  if (isHeader) {
    return (
      <SelectionHeader checked={ allRowsSelected } indeterminate={ !allRowsSelected && agentExecutionsSelected?.length > 0 } onChange={ onClick } disabled={ disabled } />
    );
  }
  return (
    <SelectionCell checked={ isSelected } onChange={ onClick } disabled={ disabled } />
  );
};

export default SelectedCell;
